import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import jmoment from 'moment-jalaali';
import Select from 'react-select';
import ENUMS from '../../enums';
import RseeTimePicker from '../../components/timePicker';
import Spin from '../../components/loading';
import * as cafeEventsActions from '../../redux/cafeEvents/actions';
import {
  formatter,
  dataGenerator,
  enumHelper,
  domManipulator,
  toastMessage,
} from '../../utils';
import DatePicker from './../../components/FormElements/DatePicker/DatePicker';

class AddOrEditCafeEvent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      titleInputValidateStatus: '',
      titleInputInvalidMessage: '',

      fromDateInputValidateStatus: '',
      fromDateInputInvalidMessage: '',

      toDateInputValidateStatus: '',
      toDateInputInvalidMessage: '',

      weekDayInputValidateStatus: '',
      weekDayInputInvalidMessage: '',

      fromTimeInputValidateStatus: '',
      fromTimeInputInvalidMessage: '',

      toTimeInputValidateStatus: '',
      toTimeInputInvalidMessage: '',

      loaded: false,
      name: '',
      eventDescription: '',
      fromDate: '',
      toDate: '',
      weekDay: null,
      fromTime: '',
      toTime: '',
      hourlyWeekDaysEventsList: [],
      hoursListInvalidMessage: '',
    };
  }

  componentDidMount() {
    this.props.actions.clearAddEventForm();
    if (this.props.location.editMode) {
      this.props.actions.fetchCafeEventDetailsById(this.props.location.eventId);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.props.location.editMode &&
      prevState.loaded == false &&
      Object.entries(this.props.cafeEventDetails).length
    ) {
      const {
        hourlyWeekDaysEventsList,
        cafeName,
        createdAt,
        name,
        id,
        updatedFullName,
        updatedAt,
        createdFullName,
        fromDate,
        toDate,
        rejectionReason,
        status,
      } = this.props.cafeEventDetails;

      this.setState({
        hourlyWeekDaysEventsList,
        cafeName,
        createdAt,
        name,
        id,
        updatedFullName,
        updatedAt,
        createdFullName,
        fromDate,
        toDate,
        rejectionReason,
        status,
        loaded: true,
      });
    }
  }

  setWeekDay = item => {
    this.setState({
      weekDay: { ...item },
      weekDayInputInvalidMessage: '',
      weekDayInputValidateStatus: '',
    });
  };

  setFromTime = time => {
    this.setState({
      fromTime: formatter.toStandard(time),
      fromTimeInputInvalidMessage: '',
      fromTimeInputValidateStatus: '',
    });
  };

  setToTime = time => {
    this.setState({
      toTime: formatter.toStandard(time),
      toTimeInputInvalidMessage: '',
      toTimeInputValidateStatus: '',
    });
  };

  handleTitleChange = event => {
    let { value } = event.target;
    this.setState({
      name: value,
      titleInputValidateStatus: '',
      titleInputInvalidMessage: '',
    });
  };

  handleEventDescriptionChange = event => {
    let { value } = event.target;
    this.setState({
      eventDescription: value,
    });
  };

  setFromDate = val => {
    this.setState({
      fromDate: val,
      fromDateInputValidateStatus: '',
      fromDateInputInvalidMessage: '',
    });
  };

  setToDate = val => {
    this.setState({
      toDate: val,
      toDateInputValidateStatus: '',
      toDateInputInvalidMessage: '',
    });
  };

  addRow = () => {
    const formattedFromTime = formatter.toStandard(this.state.fromTime);
    const formattedToTime = formatter.toStandard(this.state.toTime);
    let isWeekDayValid,
      isFromTimeValid,
      isToTimeValid,
      errors = {};

    if (!this.state.weekDay) {
      errors.weekDayInputInvalidMessage = locales(
        'messages.fieldValueIsRequired',
        {
          fieldName: locales('labels.weekday'),
        },
      );
      errors.weekDayInputValidateStatus = 'is-invalid';
      isWeekDayValid = false;
    } else {
      errors.weekDayInputInvalidMessage = '';
      errors.weekDayInputValidateStatus = '';
      isWeekDayValid = true;
    }

    if (!formattedFromTime) {
      errors.fromTimeInputInvalidMessage = locales(
        'messages.fieldValueIsRequired',
        {
          fieldName: locales('fields.fromTime'),
        },
      );
      errors.fromTimeInputValidateStatus = 'is-invalid';
      isFromTimeValid = false;
    } else {
      errors.fromTimeInputInvalidMessage = '';
      errors.fromTimeInputValidateStatus = '';
      isFromTimeValid = true;
    }

    if (!formattedToTime) {
      errors.toTimeInputInvalidMessage = locales(
        'messages.fieldValueIsRequired',
        {
          fieldName: locales('fields.toTime'),
        },
      );
      errors.toTimeInputValidateStatus = 'is-invalid';
      isToTimeValid = false;
    } else {
      errors.toTimeInputInvalidMessage = '';
      errors.toTimeInputValidateStatus = '';
      isToTimeValid = true;
    }

    if (!isWeekDayValid || !isFromTimeValid || !isToTimeValid) {
      this.setState(state => ({
        ...state,
        ...errors,
      }));
      return;
    }

    this.setState(state => {
      state.hourlyWeekDaysEventsList.push({
        weekday: this.state.weekDay.value,
        toTime: formattedToTime,
        fromTime: formattedFromTime,
        key: dataGenerator.generateKey(),
      });
      state.weekDay = null;
      state.toTime = '';
      state.fromTime = '';
      state.hoursListInvalidMessage = '';
      return '';
    });
  };

  validateForm = () => {
    return new Promise((resolve, reject) => {
      const standardTitle = formatter.toStandard(this.state.name);

      let isTitleValid,
        isFromDateValid,
        isToDateValid,
        isHourlyWeekDaysEventsListValid;

      let firstErrorElementId = '';
      let errors = {};

      if (!standardTitle) {
        errors.titleInputInvalidMessage = locales(
          'messages.fieldValueIsRequired',
          {
            fieldName: locales('tables.title'),
          },
        );
        errors.titleInputValidateStatus = 'is-invalid';
        firstErrorElementId = 'title';
        isTitleValid = false;
      } else {
        errors.titleInputInvalidMessage = '';
        errors.titleInputValidateStatus = '';
        isTitleValid = true;
      }

      if (!this.state.fromDate) {
        errors.fromDateInputInvalidMessage = locales(
          'messages.fieldValueIsRequired',
          {
            fieldName: locales('fields.from.date'),
          },
        );
        errors.fromDateInputValidateStatus = 'is-invalid';
        firstErrorElementId = 'fromDate';
        isFromDateValid = false;
      } else {
        errors.fromDateInputInvalidMessage = '';
        errors.fromDateInputValidateStatus = '';
        isFromDateValid = true;
      }

      if (!this.state.toDate) {
        errors.toDateInputInvalidMessage = locales(
          'messages.fieldValueIsRequired',
          {
            fieldName: locales('fields.to.date'),
          },
        );
        errors.toDateInputValidateStatus = 'is-invalid';
        firstErrorElementId = 'toDate';
        isToDateValid = false;
      } else {
        errors.toDateInputInvalidMessage = '';
        errors.toDateInputValidateStatus = '';
        isToDateValid = true;
      }

      if (
        !this.state.hourlyWeekDaysEventsList ||
        !this.state.hourlyWeekDaysEventsList.length
      ) {
        isHourlyWeekDaysEventsListValid = false;
        errors.hoursListInvalidMessage = locales(
          'messages.enter.at.least.one.event.time.is.mandatory',
        );
      } else {
        isHourlyWeekDaysEventsListValid = true;
        errors.hoursListInvalidMessage = '';
      }

      let isFormValid =
        isTitleValid &&
        isFromDateValid & isToDateValid &&
        isHourlyWeekDaysEventsListValid;

      if (!isFormValid) {
        this.setState(
          () => ({
            ...errors,
          }),
          () => {
            domManipulator.scrollIntoView(firstErrorElementId);
            resolve(false);
          },
        );
      } else {
        resolve(true);
      }
    });
  };

  saveForm = async event => {
    event.preventDefault();

    const isFormValid = await this.validateForm();
    if (!isFormValid) {
      return;
    }

    domManipulator.scrollToTop();

    let hourlyWeekDaysEventsList = this.state.hourlyWeekDaysEventsList;
    hourlyWeekDaysEventsList.forEach(item => delete item.key);

    const standardName = formatter.toStandard(this.state.name);
    const standardFromDate = formatter.toStandard(
      jmoment(this.state.fromDate).format('jYYYY/jMM/jDD'),
    );
    const standardToDate = formatter.toStandard(
      jmoment(this.state.toDate).format('jYYYY/jMM/jDD'),
    );

    let cafeEventObject = {
      name: standardName,
      eventDescription: this.state.eventDescription,
      fromDate: standardFromDate,
      toDate: standardToDate,
      hourlyWeekDaysEventsList,
    };

    if (!this.props.location.editMode) {
      this.props.actions.addCafeEvent(cafeEventObject).then(res => {
        const {
          addCafeEventError,
          addCafeEventFailed,
          addCafeEventMessage,
        } = this.props;
        if (
          addCafeEventError == false &&
          addCafeEventFailed == false &&
          addCafeEventMessage == null
        ) {
          this.props.history.push('/cafe-events');
          toastMessage.show({
            text: locales('titles.insertedSuccessfully'),
            icon: 'success',
          });
        } else {
          domManipulator.scrollToTop();
        }
      });
    } else {
      this.props.actions
        .updateCafeEvent({
          ...cafeEventObject,
          id: this.props.cafeEventDetails.id,
        })
        .then(res => {
          const {
            updateCafeEventError,
            updateCafeEventFailed,
            updateCafeEventMessage,
          } = this.props;
          if (
            updateCafeEventError == false &&
            updateCafeEventFailed == false &&
            updateCafeEventMessage == null
          ) {
            this.props.history.push('/cafe-events');
            toastMessage.show({
              text: locales('titles.editionsDoneSuccessfully'),
              icon: 'success',
            });
          } else {
            domManipulator.scrollToTop();
          }
        });
    }
  };

  deleteRow = index => {
    this.setState(state => {
      state.hourlyWeekDaysEventsList = [
        ...state.hourlyWeekDaysEventsList.filter((item, ind) => ind != index),
      ];
      return '';
    });
  };

  render() {
    const {
      addCafeEventLoading,
      addCafeEventMessage,
      addCafeEventFailed,
      addCafeEventError,

      updateCafeEventLoading,
      updateCafeEventMessage,
      updateCafeEventFailed,
      updateCafeEventError,

      cafeEventDetailsLoading,
      cafeEventDetailsFailed,
      cafeEventDetailsError,
      cafeEventDetailsMessage,
    } = this.props;

    const {
      name,
      eventDescription,
      weekDay,
      fromTime,
      toTime,
      hourlyWeekDaysEventsList,

      titleInputInvalidMessage,
      titleInputValidateStatus,

      fromTimeInputInvalidMessage,
      fromTimeInputValidateStatus,

      toTimeInputInvalidMessage,
      toTimeInputValidateStatus,

      fromDateInputInvalidMessage,
      fromDateInputValidateStatus,

      toDateInputInvalidMessage,
      toDateInputValidateStatus,

      weekDayInputInvalidMessage,
      weekDayInputValidateStatus,
    } = this.state;

    return (
      <Spin
        spinning={
          addCafeEventLoading ||
          cafeEventDetailsLoading ||
          updateCafeEventLoading
        }
      >
        <section className='page-header'>
          <h1>{locales('titles.eventsManagement')}</h1>
          <div className='form-actions'>
            <button onClick={this.saveForm} className='btn btn-success'>
              <i className='fa fa-save' />
              {locales('labels.save')}
            </button>
            <Link to='/cafe-events' className='btn btn-default'>
              <i className='fa fa-reply' />
              {locales('labels.cancel')}
            </Link>
          </div>
        </section>
        <section className='panel panel-default'>
          <div className='panel-heading'>
            <h3 className='panel-title'>
              <i className='fa fa-pencil'></i>
              {locales('titles.insertNewCafeEvent')}
            </h3>
          </div>
          <div className='panel-body'>
            {(addCafeEventError ||
              cafeEventDetailsError ||
              updateCafeEventError) && (
              <div className='alert alert-danger'>
                {locales('messages.server.error')}
              </div>
            )}
            {(addCafeEventFailed ||
              cafeEventDetailsFailed ||
              updateCafeEventFailed) && (
              <div className='alert alert-danger'>
                {addCafeEventMessage ||
                  cafeEventDetailsMessage ||
                  updateCafeEventMessage}
              </div>
            )}

            <div className='form-row'>
              <div className='form-group d-flex required align-items-center col-lg-4 col-12'>
                <label className='rsee-form-label text-right' htmlFor='title'>
                  {locales('tables.title')}
                </label>
                <div className='full-width'>
                  <input
                    id='title'
                    name='title'
                    type='text'
                    className={`form-control ${titleInputValidateStatus}`}
                    onChange={event => this.handleTitleChange(event)}
                    autoComplete='off'
                    value={name}
                  />
                  <div className='invalid-feedback'>
                    {titleInputInvalidMessage}
                  </div>
                </div>
              </div>
              <div className='form-group d-flex required align-items-center col-lg-4 col-12'>
                <label className='rsee-form-label text-right' htmlFor='fromDate'>
                  {locales('labels.from.date')}
                </label>

                <div className='full-width'>
                  <DatePicker
                    marge={true}
                    placeholder='تاریخ شروع'
                    id='fromDate'
                    onChange={val => this.setFromDate(val)}
                    name='fromDate'
                    className={`form-control start ${fromDateInputValidateStatus}`}
                    value={this.state.fromDate}
                  />

                  <div
                    className={`invalid-feedback ${
                      !!fromDateInputInvalidMessage ? 'is-invalid-feedback' : ''
                    }`}
                  >
                    {fromDateInputInvalidMessage}
                  </div>
                </div>
              </div>

              <div className='form-group d-flex required align-items-center col-lg-4 col-12'>
                <label className='rsee-form-label text-right' htmlFor='toDate'>
                  {locales('labels.to.date')}
                </label>

                <div className='full-width'>
                  <DatePicker
                    marge={true}
                    placeholder='تاریخ پایان'
                    id='toDate'
                    onChange={val => this.setToDate(val)}
                    name='toDate'
                    className={`form-control end ${toDateInputValidateStatus}`}
                    value={this.state.toDate}
                  />

                  <div
                    className={`invalid-feedback ${
                      !!toDateInputInvalidMessage ? 'is-invalid-feedback' : ''
                    }`}
                  >
                    {toDateInputInvalidMessage}
                  </div>
                </div>
              </div>
            </div>

            <div className='form-row'>
              <div className='form-group d-flex align-items-center col-12'>
                <label className='rsee-form-label text-right' htmlFor='title'>
                  {locales('fields.description')}
                </label>
                <div className='full-width'>
                  <textarea
                    id='eventDescription'
                    name='eventDescription'
                    type='text'
                    className={`form-control ${titleInputValidateStatus}`}
                    onChange={event => this.handleEventDescriptionChange(event)}
                    autoComplete='off'
                    value={eventDescription}
                    maxlength='100'
                    rows='3'
                  />
                  <div className='invalid-feedback'>
                    {titleInputInvalidMessage}
                  </div>
                </div>
              </div>
            </div>
            <div className='form-row'>
              
            </div>

            <h6 className='line-container'>
              <span className='line'>
                <i className='fal fa-watch px-1' />
                {locales('titles.event.running.times')}
                <i className='fal fa-watch px-1' />
              </span>
            </h6>

            <div className='invalid-feedback is-invalid-feedback'>
              {this.state.hoursListInvalidMessage}
            </div>

            <table className='table table-hover table-bordered table-striped'>
              <thead>
                <tr>
                  <th className='text-center'>{locales('tables.row')}</th>
                  <th className='text-center'>{locales('fields.week.day')}</th>
                  <th className='text-center'>{locales('tables.fromHour')}</th>
                  <th className='text-center'>{locales('tables.toHour')}</th>
                  <th className='text-center'></th>
                </tr>
              </thead>
              <tbody>
                {hourlyWeekDaysEventsList.length
                  ? hourlyWeekDaysEventsList.map((item, index) => (
                      <tr key={item.key}>
                        <td className='text-center'>{index + 1}</td>
                        <td className='text-center'>
                          {enumHelper.convertEnumValueToTitle(
                            ENUMS.WEEK_DAYS.list,
                            item.weekday,
                          )}
                        </td>
                        <td className='text-center'>{item.fromTime}</td>
                        <td className='text-center'>{item.toTime}</td>
                        <td
                          onClick={() => this.deleteRow(index)}
                          className='pointer text-center'
                        >
                          <i className='far fa-trash text-danger' />
                        </td>
                      </tr>
                    ))
                  : null}
              </tbody>
              <tfoot>
                <tr>
                  <td></td>
                  <td>
                    <div className='form-group required'>
                      <Select
                        placeholder={locales('labels.chooseDay')}
                        isMulti={false}
                        className={`rc-dropdown ${
                          !!weekDayInputValidateStatus ? 'is-invalid' : ''
                        }`}
                        name='weekday'
                        id='weekday'
                        onChange={this.setWeekDay}
                        value={weekDay}
                        options={ENUMS.WEEK_DAYS.list.map(item => ({
                          label: item.title,
                          value: item.value,
                        }))}
                      />

                      <div className='invalid-feedback'>
                        {weekDayInputInvalidMessage}
                      </div>
                    </div>
                  </td>
                  <td>
                    <div className='form-group d-flex required align-items-center'>
                      <div className='full-width'>
                        <RseeTimePicker
                          className={`${fromTimeInputValidateStatus} form-control`}
                          type='time'
                          onChange={this.setFromTime}
                          value={formatter.toStandard(fromTime)}
                          name='fromTime'
                          id='fromTime'
                          format='HH:mm'
                        />
                        <div className='invalid-feedback'>
                          {fromTimeInputInvalidMessage}
                        </div>
                      </div>
                    </div>
                  </td>
                  <td>
                    <div className='form-group d-flex required'>
                      <div className='full-width'>
                        <RseeTimePicker
                          className={`${toTimeInputValidateStatus} form-control`}
                          type='time'
                          onChange={this.setToTime}
                          value={formatter.toStandard(toTime)}
                          name='toTime'
                          id='toTime'
                          format='HH:mm'
                        />
                        <div className='invalid-feedback'>
                          {toTimeInputInvalidMessage}
                        </div>
                      </div>
                    </div>
                  </td>
                  <td>
                    <button
                      onClick={this.addRow}
                      className='btn btn-primary btn-sm'
                    >
                      {locales('labels.do.add')}
                    </button>
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        </section>
      </Spin>
    );
  }
}

const mapStateToProps = state => {
  return {
    addCafeEventLoading: state.cafeEventsReducer.addCafeEventLoading,
    addCafeEventError: state.cafeEventsReducer.addCafeEventError,
    addCafeEventFailed: state.cafeEventsReducer.addCafeEventFailed,
    addCafeEventMessage: state.cafeEventsReducer.addCafeEventMessage,

    updateCafeEventLoading: state.cafeEventsReducer.updateCafeEventLoading,
    updateCafeEventError: state.cafeEventsReducer.updateCafeEventError,
    updateCafeEventFailed: state.cafeEventsReducer.updateCafeEventFailed,
    updateCafeEventMessage: state.cafeEventsReducer.updateCafeEventMessage,

    cafeEventDetails: state.cafeEventsReducer.cafeEventDetails || {},
    cafeEventDetailsLoading: state.cafeEventsReducer.cafeEventDetailsLoading,
    cafeEventDetailsMessage: state.cafeEventsReducer.cafeEventDetailsMessage,
    cafeEventDetailsFailed: state.cafeEventsReducer.cafeEventDetailsFailed,
    cafeEventDetailsError: state.cafeEventsReducer.cafeEventDetailsError,
  };
};

const mapDispatchToProps = dispatch => ({
  actions: {
    fetchCafeEventDetailsById: id =>
      dispatch(cafeEventsActions.fetchCafeEventDetailsById(id)),
    addCafeEvent: cafeEventObject =>
      dispatch(cafeEventsActions.addCafeEvent(cafeEventObject)),
    updateCafeEvent: cafeEventObject =>
      dispatch(cafeEventsActions.updateCafeEvent(cafeEventObject)),
    clearAddEventForm: () => dispatch(cafeEventsActions.clearAddEventForm()),
  },
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(AddOrEditCafeEvent),
);
